import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="about-us-container">
        <img src="./Images/Lorevial.png" alt="Lorevial Icon" className="nav-icon" />
      <h1>Privacy Policy</h1>
<button className="home-button" onClick={() => window.location.href = '/'}>Home</button>
      <section className="about-section">
  <p>
    <strong>1. What We Gather — Only What You Offer</strong><br />
  At Lorevial, your journey begins with intention. We collect only what you choose to share: 
  selected ingredients and their nutrient details. These inputs help you explore the archive’s 
  ritual clusters and nutritional insights. No background tracking, no hidden data—just the 
  offerings you consciously select. We store this information only for users who create accounts,
   allowing for continuity, personalization, and deeper ceremonial exploration.
  </p>
</section>

<section className="about-section">
  <p>
    <strong>2. 🛡️ Data Belongs to You — Always</strong><br />
    Your nutrient rituals and ingredient selections are sacred. For signed-up users, Lorevial stores
     this data securely, using encryption and elemental safeguards to protect it from misuse or 
     unauthorized access. You remain the sole steward of your archive. We do not sell, trade, 
     or share your data—each entry is held in trust, as a vessel of memory and devotion
  </p>
</section>


<section className="about-section">
  <p>
    <strong>3. User Rights and Control</strong><br />
    Lorevial users have full control over their business data. You may update, delete, or export your records
     at any time through your dashboard. If you wish to deactivate your account or erase stored information for registered users and
      our support team will process such requests within a reasonable time frame, subject to legal and operational considerations.
  </p>
</section>

<section className="about-section">
  <p>
    <strong>4. Updates and Transparency</strong><br />
    Our privacy policy may evolve to reflect product upgrades or compliance changes. 
    All updates will be posted clearly on the site, and we encourage users to check periodically 
    for the latest version. If significant changes arise, users may be notified via email or in-app alerts.
     We’re committed to transparency and protecting your trust in Lorevial.
  </p>
</section>

    </div>
  );
}

export default PrivacyPolicy;
